export function tabs() {
    $('.tabs-holder .tabs-nav').on('click', 'a', function (e) {
        let tab = $(this).parent();
        let tabsNav = tab.closest('.tabs-nav');
        let tabIndex = tab.index();
        let tabPanel = tab.closest('.tabs-holder');
        let tabPane = tabPanel.find('.tab').eq(tabIndex);
        let totalWidth = 0;

        tabPanel.find('.active').removeClass('active');
        tabPane.addClass('active');
        tabsNav.find('li').removeClass('active');
        tab.addClass('active');

        for (let i = 0; i < tabIndex; i++) {
            totalWidth += tabsNav.find('li').eq(i).innerWidth();
        }
        tabsNav.animate({ scrollLeft: totalWidth }, 500);
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js